import api from "@/services/api";

const base = "/my-consultations";

export const consultationsApi = {
  async comingSession(filters = {}) {
    const { data } = await api.get(`${base}/coming/session`, { params: filters });
    return data;
  },

  async comingChat(filters = {}) {
    const { data } = await api.get(`${base}/coming/chat`, { params: filters });
    return data;
  },
};
